export default {"src":"/_next/static/media/virgin-islands.130b3cfd.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};